// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"25660edb","453":"d1356e7e"}[chunkId] + ".chunk.js";
};